<script>
import LogicFlow from '@qiov/logicflow-core'
import { Control } from '@logicflow/extension'
import { Menu } from '@logicflow/extension'
import '@logicflow/extension/lib/style/index.css'
import '@qiov/logicflow-core/dist/style/index.css'
import NodeRedExtension from '@/components/NodeRed/index'
// import Setting from '@/components/NodeRed/tools/Setting.vue'
import eventBus from '@/utils/eventBus'

import '@/components/NodeRed/style.css'
export default {
  name: 'FlowChart',
  data() {
    return {
      count: 0,
      currentNode: null
    }
  },
  mounted() {
    this.lf = new LogicFlow({
      container: this.$refs.container,
      grid: {
        visible: true,
        type: 'mesh',
        size: 10,
        config: {
          color: '#eeeeee'
        }
      },
      adjustEdge: true,
      hoverOutline: false,
      edgeSelectedOutline: false,
      guards: {
        beforeClone: (data) => {
          console.log('beforeClone hook:', data)
          let flag = true
          data.nodes && data.nodes.forEach((node) => {
            if (node.type === 'start-node') {
              this.$message.warning('开始节点不可复制')
              flag = false
            }
          })
          return flag
        },
        afterClone: (data) => {
          console.log('afterClone hook:', data)
          data.nodes && data.nodes.forEach((node) => {
            if (node) { // 更新复制之后的原子服务属性面板
              this.currentNode = node
              this.$emit('sendAttr', node)
            }
          })
        }
      },
      keyboard: {
        enabled: true,
        shortcuts: [
          {
            keys: ['del'],
            callback: (e) => {
              console.log('del', e)
              const elements = this.lf.getSelectElements(true)
              this.lf.clearSelectElements()
              elements.edges.forEach((edge) => this.lf.deleteEdge(edge.id))
              elements.nodes.forEach((node) => this.lf.deleteNode(node.id))
            }
          }
        ]
      },
      // keyboard: true,
      plugins: [
        Control,
        Menu,
        NodeRedExtension
      ]
    })
    this.lf.extension.menu.setMenuConfig({
      nodeMenu: [
        {
          text: '删除',
          callback: (node) => {
            this.lf.deleteNode(node.id)
          }
        },
        {
          text: '复制',
          callback: (node) => {
            const data = this.lf.cloneNode(node.id)
            console.log('after clone:', data)
            this.currentNode = data // 更新复制之后的原子服务属性面板
            this.$emit('sendAttr', this.currentNode)
          }
        }
      ], // 覆盖默认的节点右键菜单
      edgeMenu: false, // 删除默认的边右键菜单
      graphMenu: false
    })
    this.lf.extension.menu.setMenuByType({ // 开始节点无菜单
      type: 'start-node',
      menu: []
    })
    // this.lf.extension.control.addItem({
    //   iconClass: 'custom-minimap',
    //   title: '',
    //   text: '导出',
    //   onMouseEnter: (lf, ev) => {
    //     const position = lf.getPointByClient(ev.x, ev.y)
    //     lf.extension.miniMap.showMiniMap.show(
    //       position.domOverlayPosition.x - 120,
    //       position.domOverlayPosition.y + 35
    //     )
    //   },
    //   onClick: (lf, ev) => {
    //     console.log(lf.getGraphData())
    //   }
    // })
    eventBus.$on('loadNode', (param) => {
      this.lf.render(JSON.parse(param))
      eventBus.$emit('loadNodeReturn', this.lf)
    })
    this.lf.on('node-red:start', () => {
      // todo: 让流程跑起来
      console.log('我要开始执行流程了')
    })
    this.lf.on('vue-node:click', (data) => {
      this.lf.setProperties(data.id, {
        t: ++data.val
      })
    })
    this.lf.on('node:click', ({ data }) => {
      this.currentNode = null
      this.$emit('clearNode')
      this.currentNode = data
      this.$emit('sendAttr', this.currentNode)
      console.log('node click', this.currentNode)
    })
    this.lf.on('node:dnd-add', ({ data }) => {
      this.$mta.up({ ac: `as-${data.type || 'unknow-node'}` })
    })
    this.lf.on('blank:click', ({ data }) => {
      this.currentNode = null
      this.$emit('clearNode')
    })
    this.lf.on('node:delete', ({ data }) => {
      if (data.type === 'start-node') {
        this.$message.warning('请不要删除关键节点')
        this.lf.addNode(data)
        return
      }
      this.currentNode = null
      this.$emit('clearNode')
    })
  },
  methods: {
    changeStyle(style) {
      this.lf.setProperties(this.currentNode.id, {
        style
      })
    },
    getNewServe(serve) {
      this.currentNode = serve
      console.log('getNewServe', serve)
      this.lf.updateText(serve.id, serve.text.value)
      this.lf.setProperties(serve.id, serve.properties)
    }
  }
}
</script>

<template>
  <div class="flow-chart">
    <div ref="container" class="container"></div>
  </div>
</template>

<style scoped>
.container {
  width: 100%;
  height: 100%;
}
.flow-chart {
  position: relative;
  width: calc(100% - 420px);
  height: 100%;
}
.flow-chart /deep/ .lf-red-node, .flow-chart /deep/ .lf-element-text {
  cursor: move;
}
.flow-chart /deep/ svg {
  display: block;
}
.flow-chart-palette {
  position: absolute;
  left: 0;
  top: 0;
  z-index: 1;
}
.setting-panel {
  position: absolute;
  top: 0;
  right: 0;
}
/deep/.lf-menu {
  width: 100px;
}
</style>
